import React from 'react';
import './select-com.scss';
import { Search } from './search';
import Toggle from './../../../common/Toggle';
import { SimpleTooltip } from './../../../common/tooltip';

class SelectCom extends React.Component {
  renderAction = toggle => {
    return (
      <SimpleTooltip
        message={'layout.tooltipSideBar.OPEN_A_COMPONENT'}
        position={'right'}
        isI18n={true}
        appendClassName={'d-block'}
        appendStyle={{ zIndex: 99999 }}
      >
        <a href="#" onClick={toggle}>
          <i id="menu-tutorial" className="icon-application" />
        </a>
      </SimpleTooltip>
    );
  };

  getClassName = isShow => {
    return `dropdown-menu sidebar-drop ${isShow ? 'show' : ''}`;
  };

  renderPopup = (showHide, isShow) => {
    return (
      <div
        className={this.getClassName(isShow)}
        style={{
          position: 'absolute',
          willChange: 'transform',
          top: '0px',
          left: '0px',
          transform: 'translate3d(5px, 40px, 0px)',
        }}
      >
        <Search showHide={showHide} {...this.props} />
      </div>
    );
  };

  render() {
    return (
      <li className="select-com-wrap">
        <div className="side-dropdown right setting-header">
          <div className="dropdown">
            <Toggle
              renderAction={this.renderAction}
              renderPopup={this.renderPopup}
            />
          </div>
        </div>
      </li>
    );
  }
}

export default SelectCom;
